import MarkupContent from './markup-content';

export default MarkupContent;
